import { Component } from '@angular/core';
import { LoginComponent } from 'rev-shared/security/components/Login.Component';

@Component({
	selector: 'embed-webcast-login',
	template: '<vb-centered-spinner></vb-centered-spinner>',
	standalone: false
})
export class EmbedWebcastLoginComponent extends LoginComponent {

}
